import authAPI from "../api/authAPI";

const tokenKey = "jwt";

class AuthenticationManager {

    _token;
    _user = null;
    _userChangeReg = [];
    userChanged;

    tokenUpdated(newToken) {
        this._token = newToken;
        if (this.userChanged) {
            this.userChanged(this);
        }
    }

    constructor() {
        var token = window.localStorage.getItem(tokenKey);
        if (token) {
            token = JSON.parse(window.localStorage.getItem(tokenKey));
        }
        this._processToken(token);
        window.addEventListener('storage', (event) => {
            if (event.key === tokenKey) {
                var newToken = event.newValue;
                if (newToken) {
                    newToken = JSON.parse(newToken);
                }

                this._processToken(newToken);
                this.tokenUpdated(newToken);
            }
        }, false);

        // setInterval(
        //     () => this.checkTokenExpiry(this)
        //     , 60000
        // );
    }

    checkTokenExpiry(_this) {
        if (!_this) {
            _this = this;
        }
        // console.log(_this,444)
        // if (_this._user != null) {
            // let expired = _this._user.expires_in < (Date.now() - 1000 * 60 * 5) / 1000;
            // if (expired) {
                authAPI.refresh(_this.getRefreshToken())
                    .then(
                        (newToken) => {  _this.updateToken(newToken) }
                    )
                    .catch(() => {
                        _this.updateToken(null);
                        window.location.href = "/";
                    });
            // }
        // }
        return Promise.resolve();
    }

    _processToken(token) {
        if (!token) {
            return;
        }
        this._token = token;
        this._user = null;
        try {
            this._user = token;
        } catch (error) {
            console.log(error);
        }
    }

    updateToken(token) {
        this._token = token;
        this._processToken(token);
        if (token) {
            window.localStorage.setItem(tokenKey, JSON.stringify(token));
        }
        else {
            window.localStorage.removeItem(tokenKey);
        }
    }
    updatePoint(point) {
        this._token.point = point;
        if (point) {
            window.localStorage.setItem(tokenKey, JSON.stringify(this._token));
        }
        else {
            window.localStorage.removeItem(tokenKey);
        }
    }

    updateProfile(token) {
        this._token.user = token.user;
        this._token.status = token.status;
        this._token.point = token.point;
        if (token) {
            window.localStorage.setItem(tokenKey, JSON.stringify(this._token));
        }
        else {
            window.localStorage.removeItem(tokenKey);
        }
    }

    getAccessToken() {
        let result = window.localStorage.getItem(tokenKey);
        if (!result) {
            return "";
        }
        return JSON.parse(result).accessToken;
    }

    getRefreshToken() {
        let result = window.localStorage.getItem(tokenKey);
        if (!result) {
            return "";
        }
        return JSON.parse(result).refreshToken;
    }

    logout() {
        this.updateToken(null);
        document.location.reload(true)
    }
}

export default AuthenticationManager;